import { CalendarDays, Clock, User } from 'lucide-react';
import {
  formatPipelineBookingDateTime,
  getPipelineBooking,
  getPipelineBookingLabel,
} from '../../utils';
import type { Customer } from '../../types';

interface PipelineAppointmentSummaryProps {
  customer: Customer;
  variant?: 'compact' | 'detail';
}

export function PipelineAppointmentSummary({
  customer,
  variant = 'compact',
}: PipelineAppointmentSummaryProps) {
  const booking = getPipelineBooking(customer);
  if (!booking) return null;

  const label = getPipelineBookingLabel(booking);
  const dateTime = formatPipelineBookingDateTime(booking, variant === 'detail');

  if (variant === 'detail') {
    return (
      <div className="rounded-md border border-emerald-200 bg-emerald-50 p-3 text-xs text-emerald-900 dark:border-emerald-800/70 dark:bg-emerald-950/30 dark:text-emerald-200">
        <div className="flex items-center gap-2 font-medium">
          <CalendarDays className="h-4 w-4" />
          Booked Appointment
        </div>
        <div className="mt-2 grid gap-1.5">
          <div className="flex items-center gap-2">
            <Clock className="h-3.5 w-3.5" />
            <span>
              {label}
              {dateTime ? ` - ${dateTime}` : ''}
            </span>
          </div>
          {booking.staffName && (
            <div className="flex items-center gap-2">
              <User className="h-3.5 w-3.5" />
              <span>{booking.staffName}</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="mt-2 flex items-start gap-1.5 rounded-md bg-emerald-50 px-2 py-1.5 text-[11px] leading-snug text-emerald-800 dark:bg-emerald-950/30 dark:text-emerald-200">
      <CalendarDays className="mt-0.5 h-3.5 w-3.5 flex-shrink-0" />
      <span className="min-w-0">
        <span className="font-medium">{label}</span>
        {dateTime ? ` - ${dateTime}` : ''}
        {booking.staffName ? ` with ${booking.staffName}` : ''}
      </span>
    </div>
  );
}
